import { NavigationItem } from "./NavigationItem";
import { CeloIcon, NymIcon, IcpIcon } from "../Common/Icons/svgs";
import NotificationsIcon from "@mui/icons-material/Notifications";
import EditNotificationsIcon from "@mui/icons-material/EditNotifications";
import SystemSecurityUpdateGoodIcon from "@mui/icons-material/SystemSecurityUpdateGood";
import WidgetsIcon from "@mui/icons-material/Widgets";
import PublicIcon from "@mui/icons-material/Public";
import {
	CeloNetworkKey,
	IcpNetworkKey,
	NymNetworkKey,
} from "../Common/Models/CustomTypes";

export const navigationList: NavigationItem[] = [
	{
		title: "Celo",
		path: "",
		icon: <CeloIcon />,
		subItems: [
			{
				title: "Block Map (L1)",
				path: "/celo/block-map",
				icon: <WidgetsIcon />,
				parentCode: CeloNetworkKey,
			},
			{
				title: "Attestation Map (L1)",
				path: "/celo/attestations",
				icon: <SystemSecurityUpdateGoodIcon />,
				parentCode: CeloNetworkKey,
			},
			{
				title: "Community RPCs (L2)",
				path: "/celo/rpc",
				icon: <PublicIcon />,
				parentCode: CeloNetworkKey,
			},
			{
				title: "Metrics",
				path: "/celo/metrics",
				icon: <NotificationsIcon />,
				parentCode: CeloNetworkKey,
			},
			{
				title: "Subscriptions",
				path: "/celo/subscriptions",
				icon: <EditNotificationsIcon />,
				parentCode: CeloNetworkKey,
				requireAuthentication: true,
			},
		],
	},
	{
		title: "ICP",
		path: "",
		icon: <IcpIcon />,
		subItems: [
			{
				title: "Node Measurements",
				path: "/icp/measurements",
				icon: <PublicIcon />,
				parentCode: IcpNetworkKey,
			},
			{
				title: "Metrics",
				path: "/icp/metrics",
				icon: <NotificationsIcon />,
				parentCode: IcpNetworkKey,
			},
			{
				title: "Subscriptions",
				path: "/icp/subscriptions",
				icon: <EditNotificationsIcon />,
				parentCode: IcpNetworkKey,
				requireAuthentication: true,
			},
		],
	},
	{
		title: "NYM",
		path: "",
		icon: <NymIcon />,
		subItems: [
			{
				title: "Block Map",
				path: "/nym/block-map",
				icon: <WidgetsIcon />,
				parentCode: NymNetworkKey,
			},
			{
				title: "Metrics",
				path: "/nym/metrics",
				icon: <NotificationsIcon />,
				parentCode: NymNetworkKey,
			},
			{
				title: "Subscriptions",
				path: "/nym/subscriptions",
				icon: <EditNotificationsIcon />,
				parentCode: NymNetworkKey,
				requireAuthentication: true,
			},
		],
	},
];
